export const CHATBOT = {
  HEADER: {
    TITLE: 'Asistente',
    TOOLTIP_NEW: 'Nueva conversación',
    TOOLTIP_HISTORY: 'Historial de conversaciones',
  },
  DISCLAIMER:
    'Las respuestas son generadas por IA, que puede cometer errores. Revisa siempre la respuesta proporcionada.',
}
